import { ca } from '@cian/analytics';

import { TRoute } from '../../types/route';

export const trackMenuItemClick = (currentRoute: TRoute, opponentId: number) => {
  ca('eventSite', {
    action: `click_tab_${currentRoute}`,
    category: 'Chat',
    label: '',
    name: 'oldevent',
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
};

export const trackChangeListClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click_sopr',
    label: 'ChangeButton',
  });
};
